import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FUIQuantityControlComponent),
    multi: true
};

@Component({
    providers: [
        CUSTOM_VALUE_ACCESSOR
    ],
    selector: "fui-quantity-control",
    styleUrls: ["./quantity-control.component.scss"],
    templateUrl: "./quantity-control.component.html",
    standalone: false
})
export class FUIQuantityControlComponent extends FUIAbstractControl {
    @Input() public floor: number;
    @Input() public limit: number;
    @Input() public hideLimit: boolean;
    @Output() public change: EventEmitter<number> = new EventEmitter;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);

        this.floor = 0;
        this.value = 0;
    }

    override ngOnInit(): void {
        if (this.floor > 0) {
            if (this.floor > this.value) {
                this.value = this.floor;
            }
        }
    }

    /**
     * Decrement and emit the value of the control
     */
    public decrement(): void {
        if (this.value > this.floor) {
            this.value -= 1;
            this.change.emit(this.value);
        }
    }

    /**
     * Increment and emit the value of the control
     */
    public increment(): void {
        if (this.value < this.limit) {
            this.value += 1;
            this.change.emit(this.value);
        }
    }
}
